export default __webpack_public_path__ + "static/05-qs-chile-mobile-d4587bab384879cebf92be07fdbc4d9f.svg";